<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Message</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item color="secondary">
        Notify all previous shuttle passengers that a new incentive is available.
    </ion-item>

    <ion-list lines="none">
        <!-- <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate> -->
        <form name="form" (ngSubmit)="onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Campaign Message</ion-label>
                <ion-textarea data-test="rawMessage" color="secondary" type="text" rows="9" name="rawMessage"
                    #rawMessage="ngModel" [ngClass]="{ 'is-invalid': f.submitted && rawMessage.invalid }" required
                    [(ngModel)]="vm.rawMessage" id="rawMessage" autofocus="true" (ionChange)="onMessageChange()"
                    (keyup)="onKeyUp($event)" (click)="onKeyUp($event)">
                </ion-textarea>
                @if (submitted && rawMessage.invalid) {
                <div>
                    <div class="validationErrorMsg">Message is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Message Appears As:</ion-label>
                <ion-textarea data-test="renderedMessage" rows="9" readonly name="renderedMessage"
                    [(ngModel)]="vm.renderedMessage" [autoGrow]="true">
                </ion-textarea>
            </ion-item>

            <ion-item>
                <ion-badge class="ion-text-wrap" position="stacked" color="tertiary" slot="end">
                    {{message}}
                </ion-badge>
            </ion-item>
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="save" color="primary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>